var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import classNames from 'classnames';
import lodashGet from 'lodash/get';
import { ConfigConsumer } from '../config-provider';
import LocaleReceiver from '../locale-provider/LocaleReceiver';
import DefaultEmptyImg from './empty';
import Inbox from '../icon/Inbox';
import SimpleEmptyImg from './simple';
const defaultEmptyImg = <DefaultEmptyImg key="default"/>;
const simpleEmptyImg = <SimpleEmptyImg />;
const inboxEmptyImg = <Inbox />;
const Empty = (props) => (<ConfigConsumer>
    {({ getPrefixCls, direction }) => {
    const { className, prefixCls: customizePrefixCls, image = defaultEmptyImg, description, children, imageStyle, type } = props, restProps = __rest(props, ["className", "prefixCls", "image", "description", "children", "imageStyle", "type"]);
    return (<LocaleReceiver componentName="Empty">
          {(locale) => {
        const prefixCls = getPrefixCls('empty', customizePrefixCls);
        const des = typeof description !== 'undefined' ? description : locale.description;
        const alt = typeof des === 'string' ? des : 'empty';
        let imageNode = null;
        let newImage = image;
        if (type === 'horizontal' && image && lodashGet(image, 'key', '') === 'default') {
            newImage = inboxEmptyImg;
        }
        if (typeof newImage === 'string') {
            imageNode = <img alt={alt} src={newImage}/>;
        }
        else {
            imageNode = newImage;
        }
        return (<div className={classNames(prefixCls, {
            [`${prefixCls}-normal`]: newImage === simpleEmptyImg,
            [`${prefixCls}-horizontal`]: type === 'horizontal',
            [`${prefixCls}-rtl`]: direction === 'rtl',
        }, className)} {...restProps}>
                {image && (<div className={`${prefixCls}-image`} style={imageStyle}>
                    {imageNode}
                  </div>)}

                {des && <p className={`${prefixCls}-description`}>{des}</p>}
                {children && <div className={`${prefixCls}-footer`}>{children}</div>}
              </div>);
    }}
        </LocaleReceiver>);
}}
  </ConfigConsumer>);
Empty.PRESENTED_IMAGE_DEFAULT = defaultEmptyImg;
Empty.PRESENTED_IMAGE_SIMPLE = simpleEmptyImg;
Empty.PRESENTED_IMAGE_INBOX = inboxEmptyImg;
export default Empty;
